import {HttpContext} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable, Subject, tap} from "rxjs";
import {CLEAR_TOKENS_ON_RESPONSE} from "../auth/auth.constants";
import {PaymentTokenData} from "../types/payment.types";
import {CustomerBillingDetails} from "../types/customer.types";
import {EntityResponse} from "../types/types";
import {ApiService} from "./api.service";

@Injectable({
    providedIn: "root",
})
export class CustomerService extends ApiService {
    constructor() {
        super('customers');
    }

    private _customer = new Subject<CustomerBillingDetails>();

    get customer$(): Observable<CustomerBillingDetails> {
        return this._customer.asObservable();
    }

    setCustomer(customer: CustomerBillingDetails): void {
        this._customer.next(customer);
    }

    getBillingDetails(): Observable<EntityResponse<CustomerBillingDetails>> {
        return this.httpClient
            .get<EntityResponse<CustomerBillingDetails>>(this.baseUrl)
            .pipe(
                tap((customer: EntityResponse<CustomerBillingDetails>) => this.setCustomer(customer.data))
            );
    }

    addNewCreditCard(
        customerId: number | null,
        payload: PaymentTokenData,
        clearTokensOnResponse: boolean
    ): Observable<EntityResponse<CustomerBillingDetails>> {
        return clearTokensOnResponse ?
            this.httpClient.put<EntityResponse<CustomerBillingDetails>>(
                customerId ? `${this.baseUrl}/${customerId}` : this.baseUrl,
                payload,
                { context: new HttpContext().set(CLEAR_TOKENS_ON_RESPONSE, true) }
            ) :
            this.httpClient.put<EntityResponse<CustomerBillingDetails>>(
                customerId ? `${this.baseUrl}/${customerId}` : this.baseUrl,
                payload
            );
    }
}
